// extracted by mini-css-extract-plugin
export default {"axis":"ElevationChart--axis--dMNVM","yAxis":"ElevationChart--yAxis--yrCwf","xAxis":"ElevationChart--xAxis--Fkt+4"};